import React from "react";
import siteContent from "../../../generated/site-content";

function DatenschutzPage() {
  const datenschutz = siteContent.pages.datenschutz;

  return (
    <section className="w-full max-w-4xl py-4">
      <div className="max-w-3xl">
        <h1 className="theme-text text-3xl font-semibold tracking-tight sm:text-4xl">
          {datenschutz.title}
        </h1>
        <p className="theme-text-muted mt-4 text-sm leading-7 sm:text-base">
          {datenschutz.intro}
        </p>
      </div>

      <div className="mt-8 space-y-4">
        {datenschutz.notice ? (
          <section className="theme-surface-muted rounded-2xl border theme-border p-5 shadow-sm">
            <p className="theme-text-soft text-sm leading-7 sm:text-base">
              {datenschutz.notice}
            </p>
          </section>
        ) : null}

        <section className="theme-surface rounded-2xl border theme-border p-5 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {datenschutz.controllerLabel}
          </p>
          <div className="theme-text-soft mt-4 space-y-1 text-sm leading-7 sm:text-base">
            <p className="theme-text font-medium">{datenschutz.controllerName}</p>
            {datenschutz.controllerAddressLines.map((line) => (
              <p key={line}>{line}</p>
            ))}
            <p className="pt-2">
              <span className="theme-text font-medium">
                {datenschutz.controllerEmailLabel}:{" "}
              </span>
              <a className="theme-link" href={siteContent.contact.emailHref}>
                {siteContent.contact.emailLabel}
              </a>
            </p>
          </div>
        </section>

        <section className="theme-surface rounded-2xl border theme-border p-5 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {datenschutz.recipientsLabel}
          </p>
          <div className="theme-text-soft mt-4 space-y-3 text-sm leading-7 sm:text-base">
            {datenschutz.recipientsParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </section>

        <section className="theme-surface rounded-2xl border theme-border p-5 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {datenschutz.hostingLabel}
          </p>
          <div className="theme-text-soft mt-4 space-y-3 text-sm leading-7 sm:text-base">
            {datenschutz.hostingParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <p>
              <span className="theme-text font-medium">
                {datenschutz.hostingLegalBasisLabel}:{" "}
              </span>
              {datenschutz.hostingLegalBasis}
            </p>
            <p>
              <span className="theme-text font-medium">
                {datenschutz.hostingRetentionLabel}:{" "}
              </span>
              {datenschutz.hostingRetention}
            </p>
          </div>
        </section>

        <section className="theme-surface rounded-2xl border theme-border p-5 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {datenschutz.transfersLabel}
          </p>
          <div className="theme-text-soft mt-4 space-y-3 text-sm leading-7 sm:text-base">
            {datenschutz.transfersParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </section>

        <section className="theme-surface rounded-2xl border theme-border p-5 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {datenschutz.emailContactLabel}
          </p>
          <div className="theme-text-soft mt-4 space-y-3 text-sm leading-7 sm:text-base">
            {datenschutz.emailContactParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </section>

        <section className="theme-surface rounded-2xl border theme-border p-5 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {datenschutz.externalLinksLabel}
          </p>
          <div className="theme-text-soft mt-4 space-y-3 text-sm leading-7 sm:text-base">
            {datenschutz.externalLinksParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </section>

        <section className="theme-surface rounded-2xl border theme-border p-5 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {datenschutz.cookiesLabel}
          </p>
          <div className="theme-text-soft mt-4 space-y-3 text-sm leading-7 sm:text-base">
            {datenschutz.cookiesParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </section>

        <section className="theme-surface rounded-2xl border theme-border p-5 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {datenschutz.rightsLabel}
          </p>
          <ul className="theme-text-soft mt-4 list-disc space-y-2 pl-5 text-sm leading-7 sm:text-base">
            {datenschutz.rightsItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="theme-surface rounded-2xl border theme-border p-5 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {datenschutz.complaintLabel}
          </p>
          <div className="theme-text-soft mt-4 space-y-3 text-sm leading-7 sm:text-base">
            {datenschutz.complaintParagraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </section>
      </div>
    </section>
  );
}

export default DatenschutzPage;
